import { gWidgets } from "../whitelabel/brand";
import { widgets } from "./widgets";
import { enumWidgetTrigger } from "./widgets/widgetTypes";

export class QWidgetMgr {
  constructor() {
    this.fWSMgr = null;
    this.fRegistry = {};
    this.fStates = {};
    this.fWidgetConfigs = {};
  }

  InitWidgetMgr(wsMgr) {
    this.fWSMgr = wsMgr;
    for (const widget of widgets) {
      this.fRegistry[widget.type] = widget;
    }
  }

  InitializeWidgets(orgDict) {
    const knownTriggers = Object.values(enumWidgetTrigger);
    for (const type of Object.keys(gWidgets)) {
      if (this.fStates[type] === "skipped") {
        continue;
      }
      const descriptor = this.fRegistry[type];
      if (!descriptor) {
        console.warn(`[QWidgetMgr] No loader registered for widget type: ${type}`);
        continue;
      }

      const widgetConfig = gWidgets[type];
      if (!knownTriggers.includes(widgetConfig.trigger)) {
        console.warn(
          `[QWidgetMgr] Unknown trigger "${widgetConfig.trigger}" for widget type: ${type}`
        );
      }
      this.fWidgetConfigs[type] = widgetConfig;
      this.fStates[type] = "loading";

      try {
        const context = { wsMgr: this.fWSMgr, orgDict };
        const loaded = descriptor.Load(widgetConfig, context);
        this.fStates[type] = loaded ? "ready" : "skipped";
      } catch (e) {
        console.error(`[QWidgetMgr] Error loading widget: ${type}`, e);
        this.fStates[type] = "error";
      }
    }
  }

  TeardownWidgets() {
    for (const type of Object.keys(this.fWidgetConfigs)) {
      if (this.fStates[type] !== "ready") {
        continue;
      }
      const descriptor = this.fRegistry[type];
      if (descriptor?.Unload) {
        try {
          descriptor.Unload({ wsMgr: this.fWSMgr });
        } catch (e) {
          console.error(`[QWidgetMgr] Error unloading widget: ${type}`, e);
        }
      }
      delete this.fStates[type];
    }
  }

  ActivateWidget(trigger, params) {
    for (const type of Object.keys(this.fWidgetConfigs)) {
      const config = this.fWidgetConfigs[type];
      if (config.trigger === trigger && this.fStates[type] === "ready") {
        const descriptor = this.fRegistry[type];
        if (descriptor?.Activate) {
          try {
            const context = { wsMgr: this.fWSMgr, params };
            descriptor.Activate(context);
            return true;
          } catch (e) {
            console.error(`[QWidgetMgr] Error activating widget: ${type}`, e);
          }
        }
      }
    }
    return false;
  }

  GetWidgetState(type) {
    return this.fStates[type] || null;
  }

  DisableWidget(type) {
    this.fStates[type] = "skipped";
  }

  GetWSMgr() {
    return this.fWSMgr;
  }
}
